import { E2EEManagerOptions, Room } from 'livekit-client';
import E2EEWorker from 'livekit-client/e2ee-worker?worker';
import { createContext, PropsWithChildren, useEffect, useMemo } from 'react';

import { MatrixKeyProvider } from 'utils/matrixKeyProvider';

export type MatrixEncryptionContextType = {
  room: Room;
  e2eeOptions: E2EEManagerOptions;
};

export const MatrixEncryptionContext = createContext<MatrixEncryptionContextType | null>(null);

export const MatrixEncryptionProvider = ({ children }: PropsWithChildren) => {
  const e2eeOptions = useMemo(
    (): E2EEManagerOptions => ({
      keyProvider: new MatrixKeyProvider(),
      worker: new E2EEWorker(),
    }),
    []
  );

  const room = useMemo(() => {
    const r = new Room({ e2ee: e2eeOptions });

    r.setE2EEEnabled(true);
    return r;
  }, [e2eeOptions]);

  useEffect(
    () => () => {
      (e2eeOptions.keyProvider as MatrixKeyProvider).clearRTCSession();
    },
    [e2eeOptions.keyProvider]
  );

  return <MatrixEncryptionContext.Provider value={{ room, e2eeOptions }}>{children}</MatrixEncryptionContext.Provider>;
};
